import React, { useState } from 'react';
// import TableWithSummary from '../../../../components/table/TableWithSummary';
// import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
// import { useAuth } from '../../..../hooks/common/useAuth';
// import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../constants/service/common/userPermissions';
import { useQuery } from '@tanstack/react-query';
import { settlementQuery } from '../../queries';
import { convertSettlementItemsToColumns } from '../../utils';
import {
  ColumnFiltersState,
  OnChangeFn,
  PaginationState,
  RowSelectionState,
  SortingState,
} from '@tanstack/react-table';
import columns from './columns';
import { TanstackControlledTable } from '../../../../components/TanstackTable';
import useRouter from '../../../../hooks/common/useRouter';
import { StyledTableWrapper } from './styles';
import SettlementListToolbar from '../SettlementListToolbar';
import { SettlementItemsQueryParams } from '../../types/apis';
import { isAxiosError } from 'axios';

type Props = {
  request: SettlementItemsQueryParams;
  sortingState: [SortingState, OnChangeFn<SortingState>];
  filteringState: [ColumnFiltersState, OnChangeFn<ColumnFiltersState>];
  paginationState: [PaginationState, OnChangeFn<PaginationState>];
  type: 'ready' | 'completed' | 'hold';
  onResetFilter: () => void;
};

const SettlementList = ({
  request,
  sortingState,
  filteringState,
  paginationState,
  type,
  onResetFilter,
}: Props): JSX.Element => {
  // const { can } = useAuth();

  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});

  const selectedKeys = Object.keys(rowSelection);

  const handleResetRowSelection = (): void => {
    setRowSelection({});
  };

  const { data, isError, error } = useQuery({
    ...settlementQuery.list(request),
    select: ({ totalCount, settlementItems }) => {
      return { rowCount: totalCount, settlementItems: convertSettlementItemsToColumns(settlementItems) };
    },
    keepPreviousData: true,
    onSettled: handleResetRowSelection,
  });

  const selectedItems = data?.settlementItems
    ? data?.settlementItems.filter((_, index) => selectedKeys.includes(String(index)))
    : [];

  if (isError) {
    if (isAxiosError(error)) {
      throw new Error(`SettlementList: ${error.message}`);
    }

    throw new Error(`SettlementList: ${error}`);
  }

  return (
    <>
      <StyledTableWrapper>
        <SettlementListToolbar
          type={type}
          totalCount={data?.rowCount ?? 0}
          request={request}
          bulkItems={selectedItems}
          onResetFilter={onResetFilter}
        />
        <TanstackControlledTable
          emptyText="요청하신 검색 필터로 검색된 정산 리스트가 없습니다."
          data={data?.settlementItems ?? []}
          columns={columns}
          sortingState={sortingState}
          filteringState={filteringState}
          rowSelectionState={['ready', 'hold'].includes(type) ? [rowSelection, setRowSelection] : undefined}
          paginationState={paginationState}
          columnPinning={['id', 'brandName', 'brandId']}
          rowCount={data?.rowCount ? data?.rowCount : 0}
        />
      </StyledTableWrapper>
    </>
  );

  {
    /* <TableWithSummary
        totalCnt={mockSettlementItems.length}
        head={
          <Fragment>
            <Button
              isRadius
              color="primary"
              text="정산 아이템 엑셀 다운"
              // onClick={() => getBalanceItemListExcelDownload()}
            />
            {can(PERMISSION_ACTIONS.UPDATE, PERMISSION_SUBJECTS.BALANCE) ? (
              <Button
                isRadius
                color="light"
                text="정산 일괄 처리"
                // onClick={() => bulkEditBalance()}
              />
            ) : null}
          </Fragment>
        }
        initialOption={{
          pagination: SETTLEMENT_SORT_PAGINATION_MODEL,
        }}
        emptyText={BALANCE_LIST_TABLE_EMPTY_TEXT}
        showPagination
      /> */
  }
};

const Placeholder = ({
  sortingState,
  filteringState,
  paginationState,
  type,
}: Pick<Props, 'sortingState' | 'filteringState' | 'paginationState' | 'type'>): JSX.Element => {
  const router = useRouter();

  const { query } = router;

  const [rowSelection, setRowSelection] = useState<RowSelectionState>(
    typeof query.rowSelection === 'string' ? JSON.parse(query.rowSelection) : {},
  );

  return (
    <>
      <StyledTableWrapper>
        <SettlementListToolbar.Placeholder type={type} />
        <TanstackControlledTable
          emptyText="요청하신 검색 필터로 검색된 정산 리스트가 없습니다."
          data={[]}
          columns={columns}
          sortingState={sortingState}
          filteringState={filteringState}
          rowSelectionState={[rowSelection, setRowSelection]}
          paginationState={paginationState}
          columnPinning={['id', 'brandName', 'brandId']}
          rowCount={0}
        />
      </StyledTableWrapper>
    </>
  );
};

SettlementList.Placeholder = Placeholder;

export default SettlementList;
